import i18n from 'locales/i18n';
import { Gender } from 'types';

export const GenderTranslationsMap: { [key in Gender]: string } = {
  [Gender.Male]: i18n.t('gender.male'),
  [Gender.Female]: i18n.t('gender.female'),
  [Gender.NotSpecified]: i18n.t('gender.notSpecified'),
};
